import jsPDF from 'jspdf';
import React, { useState, useRef, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModalSilla from '../components/ModalSilla';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import logo from '../assets/gorion.png';
import './HHServicios.css';
import axios from 'axios';
import API_BASE_URL from '../config';
const moment = require('moment-timezone');

const ServicePage = () => {
  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : {};
  const user = JSON.parse(localStorage.getItem('user')) || {};

  const noColaborador = decoded?.id;
const estacionUsuario = decoded?.estacion;
const rol = decoded?.rol;

  useEffect(() => {
  if (estacionUsuario === 'MEXT2' && decoded.id) {
    setFormData((prev) => ({
      ...prev,
      estacion: estacionUsuario,
      noColaborador: decoded.id,
      usuarioInicio: decoded.id,
    }));
  }
}, [estacionUsuario, decoded.id]);


  const [isModalSillaOpen, setIsModalSillaOpen] = useState(false);
  const [isModalAsignarOpen, setIsModalAsignarOpen] = useState(false);
  const [searchColaborador, setSearchColaborador] = useState('');
  const [colaboradores, setColaboradores] = useState([]);
  const [errores, setErrores] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    usuarioInicio: user.noColaborador || 'SISTEMA',
    estacion: user.estacion || 'Estación no especificada',
    fechaInput: new Date().toISOString().split('T')[0],
    noColaborador: '',
    qr: '',
    sillaAsignada: '',
    sillaRuedas: '',
    observaciones: '',
    eta: '',
    tipoSilla: 'WCHR',
    servicioSolicitado: 'P. ATENCION',
    tipoVuelo: 'CONTACTO',
    origen: 'RESERVACION',
    nombrePax: '',
    noVuelo: '',
    aerolinea: '',
    noAsiento: '',
    origenVuelo: '',
    destinoVuelo: '',
  });

  const processQRCode = (qrText) => {
    const match = qrText.match(/M1(.{1,20})/);
    const nombrePax = match ? match[1] : '';
    const noVuelo = qrText.substring(39, 43) || '';
    const aerolinea = qrText.substring(36, 38) || '';
    const noAsiento = qrText.substring(49, 52) || '';
    const origenVuelo = qrText.substring(30, 33) || '';
    const destinoVuelo = qrText.substring(33, 36) || '';
    setFormData((prevData) => ({
      ...prevData,
      nombrePax,
      noVuelo,
      aerolinea,
      noAsiento,
      origenVuelo,
      destinoVuelo,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchOperatorDetails = async (colaboradorId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}api/operadores/${colaboradorId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const { siglas, tia, sillaAsignada } = response.data;

      setFormData((prev) => ({
        ...prev,
        siglas,
        tia,
        sillaAsignada,
      }));
    } catch (error) {
      console.error('Error al obtener los detalles del operador:', error);
      toast.error('Error al obtener los detalles del operador');
    }
  };

  useEffect(() => {
    if (formData.noColaborador) {
      fetchOperatorDetails(formData.noColaborador);
    }
  }, [formData.noColaborador]);

  useEffect(() => {
    if (formData.tipoSilla === 'SILLA PROPIA') {
      setFormData((prev) => ({
        ...prev,
        sillaRuedas: 'SILLA PROPIA',
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        sillaRuedas: prev.sillaAsignada || '',
      }));
    }
  }, [formData.tipoSilla, formData.sillaAsignada]);

  const handleGeneratePDF = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}api/operadores/${formData.noColaborador}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const operadorAsign = response.data;
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [58, 120],
      });

      doc.addImage(logo, 'PNG', 4, 4, 50, 20);
      doc.setFontSize(12);
      doc.text(
        `Fecha: ${moment().tz('America/Mexico/City').format('YYYY-MM-DD HH:mm:ss')}`,
        4,
        30
      );

      doc.setFontSize(10);
      doc.text(`Aerolinea: ${formData.aerolinea}`, 4, 35);
      doc.text(`No. Vuelo: ${formData.noVuelo}`, 4, 40);
      doc.text(
        `Operador: ${operadorAsign.nombre} ${operadorAsign.apellidos} - ${formData.noColaborador}`,
        4,
        45
      );
      doc.text(`No. TIA: ${operadorAsign.tia || '2502432'}`, 4, 50);
      doc.text(`Silla: ${formData.sillaRuedas}`, 4, 55);

      const passengerText = `Pasajero: ${formData.nombrePax}`;
      const maxWidth = 50;
      const splitPassengerText = doc.splitTextToSize(passengerText, maxWidth);
      let currentY = 60;
      doc.text(splitPassengerText, 4, currentY);
      currentY += splitPassengerText.length * 5;

      doc.setFontSize(12);
      doc.text('------------------------------------------', 4, currentY);
      currentY += 5;
      doc.setFontSize(9);
      doc.text('La calidad en el servicio nos caracteriza,', 4, currentY);
      currentY += 5;
      doc.text('Servicio gratuito', 4, currentY);
      currentY += 5;
      doc.text('Quejas: 55-2729-1171', 4, currentY);
      currentY += 5;
      doc.setFontSize(12);
      doc.text('-----------------------------------------', 4, currentY);
      currentY += 5;
      doc.text('-----------------------------------------', 4, currentY);
      currentY += 5;
      doc.text('-----------------------------------------', 4, currentY);

      const pdfURL = doc.output('bloburl');
      window.open(pdfURL, '_blank');
    } catch (error) {
      toast.error('Error al imprimir el servicio', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const abrirModalAsignar = async () => {
    setIsModalAsignarOpen(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}api/bitacora/en-turno-detalles`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const colaboradoresFiltrados = response.data.filter(
        (col) => col.estacion?.trim().toUpperCase() === estacionUsuario
      );
      setColaboradores(colaboradoresFiltrados);
    } catch (error) {
      console.error('Error al obtener colaboradores en turno con detalles:', error);
      setColaboradores([]);
    }
  };

  const seleccionarColaborador = (colaborador) => {
    setFormData((prev) => ({
      ...prev,
      noColaborador: colaborador.noColaborador,
    }));
    setIsModalAsignarOpen(false);
  };

  const filteredColaboradores = searchColaborador.trim()
    ? colaboradores.filter((colaborador) =>
        (colaborador.siglas || '').toLowerCase().includes(searchColaborador.toLowerCase())
      ).slice(0, 1)
    : [];

  const handleSubmit = async (e) => {
    e.preventDefault();
    const camposSelect = ['tipoSilla', 'servicioSolicitado', 'tipoVuelo', 'origen'];
    const nuevosErrores = {};
    camposSelect.forEach((campo) => {
      if (!formData[campo]) nuevosErrores[campo] = true;
    });

    if (Object.keys(nuevosErrores).length > 0) {
      setErrores(nuevosErrores);
      toast.warning("Selecciona una opción válida en todos los campos requeridos.");
      return;
    }

    setErrores({});
    setIsSubmitting(true);

    try {
      const sillaFinal =
  typeof formData.sillaRuedas === 'string' && formData.sillaRuedas.trim() !== ''
    ? formData.sillaRuedas.trim()
    : `${estacionUsuario}-999`;

const datosAEnviar = {
  ...formData,
  sillaRuedas: sillaFinal,
  sillaAsignada: sillaFinal,
  eta: formData.eta || '00:00',
};


console.log("🧾 Datos enviados al backend:", datosAEnviar);

await axios.post(`${API_BASE_URL}api/servicios`, datosAEnviar, {
  headers: { Authorization: `Bearer ${token}` },
});


      toast.success('Servicio registrado correctamente', {
        position: 'top-right',
        autoClose: 3000,
      });

      handleGeneratePDF();
      setTimeout(() => window.location.reload(), 3000);
    } catch (error) {
      console.error('Error al registrar el servicio:', error);
      toast.error('Error al registrar el servicio', {
        position: 'top-right',
        autoClose: 3000,
      });
      setTimeout(() => window.location.reload(), 10000);
    } finally {
      setIsSubmitting(false);
    }
  };
  

  return (
    <div className="service-page">
      <ToastContainer />
      <h3>Estación actual: {estacionUsuario}</h3>

      <h1>Registro de Servicios</h1>

      {/* Modal para escaneo NFC de silla */}
      {isModalSillaOpen && (
        <ModalSilla
          onClose={() => setIsModalSillaOpen(false)}
          onSillaAsignada={(nfcData) =>
            setFormData((prev) => ({ ...prev, sillaRuedas: nfcData }))
          }
        />
      )}

      {/* Modal para asignación de colaborador */}
      {isModalAsignarOpen && (
        <div
          className="modal-overlay"
          onClick={() => setIsModalAsignarOpen(false)}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Asignar a Colaborador</h2>
            <input
              type="text"
              placeholder="Buscar por nombre o siglas..."
              value={searchColaborador}
              onChange={(e) => setSearchColaborador(e.target.value)}
              className="form-control"
              style={{ marginBottom: '10px' }}
            />
            <ul className="colaboradores-list">
              {filteredColaboradores.map((colaborador) => (
                <li
                  key={colaborador.noColaborador}
                  onClick={() => seleccionarColaborador(colaborador)}
                  className={`colaborador-item ${
                    colaborador.noFila === 1 ? 'recomendado' : ''
                  }`}
                >
                  {`#Fila: ${colaborador.noFila}, Colaborador: ${colaborador.noColaborador} (${colaborador.siglas}), Nombre: ${colaborador.nombreCompleto}`}
                  {colaborador.noFila === 1 && (
                    <span className="badge">Recomendado</span>
                  )}
                </li>
              ))}
            </ul>
            <button
              className="btn-close"
              onClick={() => setIsModalAsignarOpen(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

      {/* Formulario */}
      <form className="service-form" onSubmit={handleSubmit}>
        {/* Campo de QR sin botón de escaneo */}
        <div className="form-group">
          <label>QR Pase de Abordar</label>
          <input
            type="text"
            name="qr"
            value={formData.qr}
            onChange={handleInputChange}
            onBlur={(e) => processQRCode(e.target.value)}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Nombre Pax</label>
          <input
            type="text"
            name="nombrePax"
            value={formData.nombrePax}
            readOnly
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Aerolínea</label>
          <input
            type="text"
            name="aerolinea"
            value={formData.aerolinea}
            readOnly
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Número de Vuelo</label>
          <input
            type="text"
            name="noVuelo"
            value={formData.noVuelo}
            readOnly
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Número de Asiento</label>
          <input
            type="text"
            name="noAsiento"
            value={formData.noAsiento}
            readOnly
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Origen Vuelo</label>
          <input
            type="text"
            name="origenVuelo"
            value={formData.origenVuelo}
            readOnly
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Destino Vuelo</label>
          <input
            type="text"
            name="destinoVuelo"
            value={formData.destinoVuelo}
            readOnly
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Fecha</label>
          <input
            type="text"
            name="fechaInput"
            value={formData.fechaInput}
            readOnly
            className="form-control"
          />
        </div>
        {/* Los campos de Estación y Usuario que Inicia se han eliminado del formulario */}
        {estacionUsuario !== 'MEXT2' && (
  <div className="form-group">
    <label>Asignar a:</label>
    <input
      type="text"
      name="noColaborador"
      value={formData.noColaborador}
      onChange={handleInputChange}
      className="form-control"
    />
    <button
      type="button"
      className="btn-camera"
      onClick={abrirModalAsignar}
    >
      Asignar
    </button>
  </div>
)}

        {/* Tipo de silla (subido aquí) */}
<div className="form-group">
  <label>Tipo de Silla</label>
  <select
  name="tipoSilla"
  value={formData.tipoSilla}
  onChange={(e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      tipoSilla: value,
      sillaRuedas:
        value === 'SILLA PROPIA'
          ? 'SILLA PROPIA'
          : prev.sillaAsignada || '',
    }));
    setErrores((prev) => ({ ...prev, tipoSilla: false }));
  }}
  
  className={`form-control ${errores.tipoSilla ? 'error-input' : ''}`}
>

  <option value="">Selecciona una opción</option>
  <option>WCHR</option>
  <option>WCHC</option>
  <option>UH</option>
  <option>SILLA PROPIA</option>
</select>

</div>
<div className="form-group">
  <label>Silla de Ruedas</label>
  <div className="input-group">
  <input
  type="text"
  name="sillaRuedas"
  value={formData.sillaRuedas}
  readOnly={formData.tipoSilla === "SILLA PROPIA"}
  onChange={(e) =>
    setFormData((prev) => ({
      ...prev,
      sillaRuedas: e.target.value,
    }))
  }
  className="form-control"
/>

    
  </div>
</div>
        <div className="form-group">
          <label>Observaciones</label>
          <input
            type="text"
            name="observaciones"
            value={formData.observaciones}
            onChange={handleInputChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>ETA</label>
          <input
            type="time"
            name="eta"
            value={formData.eta}
            onChange={handleInputChange}
            className="form-control"
          />
        </div>
        
        <div className="form-group">
          <label>Servicio Solicitado</label>
          <select
            name="servicioSolicitado"
            value={formData.servicioSolicitado}
            onChange={handleInputChange}
            className="form-control"
          >
            <option value="">Selecciona una opción</option>
            <option>P. ATENCION</option>
            <option>MOSTRADOR</option>
            <option>SALA</option>
          </select>
        </div>
        <div className="form-group">
          <label>Tipo de Vuelo</label>
          <select
            name="tipoVuelo"
            value={formData.tipoVuelo}
            onChange={handleInputChange}
            className="form-control"
          >
            <option value="">Selecciona una opción</option>
            <option>CONTACTO</option>
            <option>REMOTA</option>
            <option>ABORDAJE</option>
            <option>RECIBO</option>
          </select>
        </div>
        <div className="form-group">
          <label>Origen</label>
          <select
            name="origen"
            value={formData.origen}
            onChange={handleInputChange}
            className="form-control"
          >
            <option>RESERVACION</option>
            <option>AEROPUERTO</option>
          </select>
        </div>
        <button type="submit" className="btn-submit" disabled={isSubmitting}>
  {isSubmitting ? "Registrando..." : "Registrar Servicio"}
</button>

      </form>
    </div>
  );
};

export default ServicePage;
